// ** React Imports
import React, {useEffect} from "react";

// ** Assets Imports
import image from "../assets/images/bg_img_2.jpg";

// ** Custom Imports
import ResultCard from "../components/cards/ResultCard";

// ** React navigation imports
import {useLocation} from "react-router-dom";

const ResultsPage = () => {
  const backgroundStyle = {
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${image})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    width: "100vw",
    height: "100vh",
  };

    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

  return (
    <>
      
      <div
        style={backgroundStyle}
        className={"w-screen h-screen flex justify-center items-center"}
      >
        <ResultCard />
      </div>
    </>
  );
};

export default ResultsPage;
